var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "field" },
    [
      _c("md-input", {
        attrs: { type: "hidden" },
        model: {
          value: _vm.selectedOption,
          callback: function ($$v) {
            _vm.selectedOption = $$v
          },
          expression: "selectedOption",
        },
      }),
      _c("vue-select", {
        attrs: {
          reduce: function (r) {
            return r
          },
          label: "code",
          options: _vm.optionList,
          searchable: _vm.$root.isDesktop,
          "append-to-body": "",
        },
        scopedSlots: _vm._u(
          [
            _vm.showTooltip
              ? {
                  key: "option",
                  fn: function (ref) {
                    var code = ref.code
                    var description = ref.description
                    return [
                      _c("span", [_vm._v(_vm._s(code))]),
                      _c("md-tooltip", { attrs: { "md-direction": "right" } }, [
                        _c("span", [_vm._v(_vm._s(description))]),
                      ]),
                    ]
                  },
                }
              : {
                  key: "option",
                  fn: function (ref) {
                    var code = ref.code
                    return [
                      _vm._v("\n            " + _vm._s(code) + "\n        "),
                    ]
                  },
                },
          ],
          null,
          true
        ),
        model: {
          value: _vm.selectedOption,
          callback: function ($$v) {
            _vm.selectedOption = $$v
          },
          expression: "selectedOption",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }